//Mensaje del popover (Por defecto).
let currentPopoverData = 'Field message content';

//Instancia de la vista.
let root;

//Listado de validaciones.
let indexChecker = {
  requireField: 'requireField',
  onlyLowerCase: 'onlyLowerCase',
  onlyLetterField: 'onlyLetterField',
  onlyNumberField: 'onlyNumberField',
  shortField: 'shortField',
  longField: 'longField',
  onlyPhoneCodeField: 'onlyPhoneCodeField',
  emailField: 'emailField',
  alphaNumericField: 'alphaNumericField',
  userNameField: 'userNameField',
};

//Mensajes de notificacion de validación.
let formFieldMessage = {
  requireField: 'Campo es requerido',
  onlyLowerCase: 'Campo no acepta letras mayusculas',
  onlyLetterField: 'Campo solo puede llevar letras',
  onlyNumberField: 'Campo solo puede llevar numeros',
  shortField: 'Campo no supera el mínimo permitido.',
  longField: 'Campo supera el máximo permitido.',
  onlyPhoneCodeField: 'Campo solo puede llevar codigo telefonico (Ejemplo: 123 o +123)',
  emailField: 'Campo debe ser un correo. [Ejemplo: ejemplo@ejemplo.com]',
  alphaNumericField: 'Campo solo puede llevar letras y números. [Ejemplo: ejemplo123]',
  userNameField: 'Campo solo puede llevar letras, números. [Caracteres especiales permitidos:".", "-" o "_"]',
};

/**Función que valida la presencia de contenido del campo.
 *
 * @param {*} fieldForm, el campo a validar.
 * @returns booleano.
 */
function validateRequireField(fieldForm) {
  //console.log("           validando contenido no nulo...["+typeof(fieldForm)+"]");
  return fieldForm !== null && fieldForm !== '' && fieldForm !== undefined;
}

/**Función que valida el contenido único de letras del campo.
 *
 * @param {*} fieldForm, el campo a validar.
 * @returns booleano.
 */
function validateOnlyLetterField(fieldForm) {
  //console.log("           validando solo letras...["+typeof(fieldForm)+"]");
  if (!/^[a-zA-ZñÑäàáÁëèéÉïìíÍöòóÓüùúÚ\s]*$/g.test(fieldForm)) {
    return false;
  }
  return true;
}

/**Función que valida el contenido único de números del campo.
 *
 * @param {*} fieldForm, el campo a validar.
 * @returns booleano.
 */
function validateOnlyNumberField(fieldForm) {
  //console.log("           validando solo numeros...["+typeof(fieldForm)+"]");
  if (!/(^[|\\+|0-9][0-9]*)(\.*)[0-9]*$/.test(fieldForm)) {
    return false;
  }
  return true;
}

/**Función que valida el mínimo o máximo del campo, según corresponda.
 *
 * @param {*} fieldForm, el campo a validar.
 * @param {*} length, el largo referencial de validación.
 * @param {*} minMax, indicador para verificar máximo o mínimo.
 * @returns booleano.
 */
function validateLengthField(fieldForm, length, minMax) {
  if (minMax == 'max') {
    //console.log("           validando maximo...["+typeof(fieldForm)+"]")
    if (fieldForm == undefined) {
      return true;
    }
    formFieldMessage.longField = 'Campo supera el máximo permitido.';
    if (fieldForm.length > length) {
      formFieldMessage.longField = formFieldMessage.longField + '(Máx. ' + length + ')';
      return false;
    }
    return true;
  } else {
    //console.log("           validando minimo...["+typeof(fieldForm)+"]")
    if (fieldForm == undefined) {
      return false;
    }
    if (fieldForm.length < length) {
      formFieldMessage.shortField = 'Campo no supera el mínimo permitido.';
      formFieldMessage.shortField = formFieldMessage.shortField + '(Mín. ' + length + ')';
      return false;
    }
    return true;
  }
}

/**Función que verifica el código telefónico del campo.
 *
 * @param {*} fieldForm, el campo a validar.
 * @returns booleano.
 */
function validatePhoneCodeField(fieldForm) {
  //console.log("           validando codigo telefonico...["+typeof(fieldForm)+"]")
  //Verifica que el contenido tenga numeros y el caracter '+'.
  const re = /^(?:(?:\+?\d{1,3})[-\s]?)?(?:\d+[-\s]?)*\d+$/;
  return re.test(fieldForm);
}
/**Función que verifica la contraseña del cmapo.
 *
 * @param {*} fieldForm, el campo a validar.
 * @returns booleano.
 */
function validatePassWordField(fieldForm) {
  const minimalLength = fieldForm.trim().length >= 8;
  let re = /[A-Z]+/;
  const upperCase = re.test(fieldForm.trim());
  re = /[a-z]+/;
  const lowerCase = re.test(fieldForm.trim());
  re = /[0-9]+/;
  const numberValid = re.test(fieldForm.trim());
  re = /[^\w\s]+/;
  const specialCharacterValid = re.test(this.selectedUser.password.trim());

  return minimalLength && upperCase && lowerCase && numberValid && specialCharacterValid
}
/**Función que verifica el email del campo.
 *
 * @param {*} fieldForm, el campo a validar.
 * @returns booleano.
 */
function validateEmailField(fieldForm) {
  //Verifica que todo el campo posea los caracteres validos para un correo.
  if(fieldForm) fieldForm = fieldForm.trim();
  let checker = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (!checker.test(fieldForm)) {
    //console.log("CARACTERES INVALIDOS.")
    return false;
  }
  //Verifica que el primer caracter solo sea un número o letra.
  checker = /^[0-9a-zA-Z]+$/;
  if (!checker.test(fieldForm.charAt(0))) {
    //console.log("PRIMER CARACTER NO ES LETRA/NUMERO")
    return false;
  }
  //Obtiene la posicion del '@'.
  let delimiterPosition = fieldForm.indexOf('@');
  //Verifica que el caracter anterior al '@' solo sea un número o letra.
  if (!checker.test(fieldForm.charAt(delimiterPosition - 1))) {
    //console.log("CARACTER ANTERIOR A @ NO ES LETRA/NUMERO")
    return false;
  }
  //Verifica que no se repitan caracteres especiales.
  let specialCharCounter = 0;
  for (let i = 0; i < fieldForm.length; i++) {
    if (!checker.test(fieldForm.charAt(i))) {
      specialCharCounter++;
    } else {
      specialCharCounter = 0;
    }
    if (specialCharCounter == 2) {
      //console.log("SE REPITEN CARACTERES ESPECIALES.")
      return false;
    }
  }
  //Obtiene la posicion del limite del dominio.
  let domainLimitPosition = fieldForm.indexOf('.', delimiterPosition);
  //Obtiene el nombre del dominio.
  let domain = '';
  for (let i = delimiterPosition + 1; i < domainLimitPosition; i++) {
    domain = domain + fieldForm.charAt(i);
  }
  //Verifica que el dominio solo tenga caracteres alfanumericos.
  checker = /^[a-zA-Z0-9.-]*$/g;
  if (!checker.test(domain)) {
    //console.log("DOMINIO INVALIDO ")
    return false;
  }
  //Verifica que el dominio de alto nivel solo tenga letras en minuscula o '.'.
  checker = /^[a-z.]*$/g;
  domain = '';
  for (let i = domainLimitPosition + 1; i < fieldForm.length; i++) {
    domain = domain + fieldForm.charAt(i);
  }
  return checker.test(domain);
}

/**Función que verifica que el campo sea alfanumérico.
 *
 * @param {*} fieldForm, el campo a validar.
 * @returns booleano.
 */
function validateAlphaNumericField(fieldForm) {
  //Verifica que el campo solo tenga caracteres alfanumericos.
  let checker = /^[a-zA-Z0-9]*$/g;
  if (!checker.test(fieldForm)) {
    return false;
  }
  return true;
}

/**Función que verifica que el campo sea alfanumérico y que pueda contener ciertos caracteres especiales.
 *
 * @param {*} fieldForm, el campo a validar.
 * @returns booleano.
 */
function validateUserNameField(fieldForm) {
  //Verifica que el campo solo tenga caracteres alfanumericos, y algunos caracteres especiales.
  let checker = /^[a-zA-Z0-9._-]*$/g;
  //Verifico igual que el campo solo tenga maximo 20 caracteres
  return checker.test(fieldForm);
}

/**Función que verifica que el campo posea solo letras minusculas.
 *
 * @param {*} fieldForm, el campo a validar.
 * @returns booleano.
 */
function validateOnlyLowerCase(fieldForm) {
  //Verifica que el campo solo tenga letras minusculas.
  var i = 0;
  var character = '';
  var result = true;
  while (i <= fieldForm.length) {
    character = fieldForm.charAt(i);
    if (isNaN(character * 1) && character == character.toUpperCase() && character.match(/[a-zA-Z]/)) {
      result = false;
      break;
    }
    i++;
  }
  return result;
}

/**Función que verifica el resultado de la validación solicitada.
 *
 * @param {*} checkResult, el resultado de la validación realizada.
 * @param {*} id, el campo involucrado en la validacón.
 * @returns id del campo involucrado (-1 si pasa la prueba).
 */
function checkValidation(checkResult, id) {
  if (!checkResult) {
    //console.log("           NO CUMPLE")
    return id;
  }
  //console.log("           EXITO")
  return '-1';
}

/**Función que se encarga de gestionar las validaciones solicitadas por un campo.
 *
 * @param {*} parameterField, parametros del campo.
 * @param {*} fieldForm, valor del campo ingresado.
 * @param {*} result, arreglo que contiene la id del campo y la condición que no haya pasado la validación.
 * @returns result.
 */
function validateFormField(parameterField, fieldForm, result) {
  try {
    fieldForm = fieldForm.trim();
  } catch (e) {
    //console.log(e);
  }

  for (let value of parameterField.condition) {
    //Si el resultado es negativo, corta el ciclo.
    if (result[0] != '-1') {
      break;
    }
    switch (value) {
      case indexChecker.requireField:
        //console.log("   Validando el contenido: '"+parameterField.id+"', contenido: '"+fieldForm+"'")
        //console.log("       condicion: "+value)
        result[0] = checkValidation(validateRequireField(fieldForm), parameterField.id);
        result[1] = value;
        break;
      case indexChecker.onlyLetterField:
        //console.log("   Validando el contenido: '"+parameterField.id+"', contenido: '"+fieldForm+"'")
        //console.log("       condicion: "+value)
        result[0] = checkValidation(validateOnlyLetterField(fieldForm), parameterField.id);
        result[1] = value;
        break;
      case indexChecker.onlyNumberField:
        //console.log("   Validando el contenido: '"+parameterField.id+"', contenido: '"+fieldForm+"'")
        //console.log("       condicion: "+value)
        result[0] = checkValidation(validateOnlyNumberField(fieldForm), parameterField.id);
        result[1] = value;
        break;
      case indexChecker.shortField:
        //console.log("   Validando el contenido: '"+parameterField.id+"', contenido: '"+fieldForm+"'")
        //console.log("       condicion: "+value)
        result[0] = checkValidation(validateLengthField(fieldForm, parameterField.min, 'min'), parameterField.id);
        result[1] = value;
        break;
      case indexChecker.longField:
        //console.log("   Validando el contenido: '"+parameterField.id+"', contenido: '"+fieldForm+"'")
        //console.log("       condicion: "+value)
        result[0] = checkValidation(validateLengthField(fieldForm, parameterField.max, 'max'), parameterField.id);
        result[1] = value;
        break;
      case indexChecker.onlyPhoneCodeField:
        //console.log("   Validando el contenido: '"+parameterField.id+"', contenido: '"+fieldForm+"'")
        //console.log("       condicion: "+value)
        result[0] = checkValidation(validatePhoneCodeField(fieldForm), parameterField.id);
        result[1] = value;
        break;
      case indexChecker.passwordField:
        result[0] = checkValidation(validatePassWordField(fieldForm),parameterField.id)
        result[1] = value;
        break;
      case indexChecker.emailField:
        //console.log("   Validando el contenido: '"+parameterField.id+"', contenido: '"+fieldForm+"'")
        //console.log("       condicion: "+value)
        result[0] = checkValidation(validateEmailField(fieldForm), parameterField.id);
        result[1] = value;
        break;
      case indexChecker.alphaNumericField:
        //console.log("   Validando el contenido: '"+parameterField.id+"', contenido: '"+fieldForm+"'")
        //console.log("       condicion: "+value)
        result[0] = checkValidation(validateAlphaNumericField(fieldForm), parameterField.id);
        result[1] = value;
        break;
      case indexChecker.userNameField:
        //console.log("   Validando el contenido: '"+parameterField.id+"', contenido: '"+fieldForm+"'")
        //console.log("       condicion: "+value)
        result[0] = checkValidation(validateUserNameField(fieldForm), parameterField.id);
        result[1] = value;
        break;
      case indexChecker.onlyLowerCase:
        //console.log("   Validando el contenido: '"+parameterField.id+"', contenido: '"+fieldForm+"'")
        //console.log("       condicion: "+value)
        result[0] = checkValidation(validateOnlyLowerCase(fieldForm), parameterField.id);
        result[1] = value;
        break;
    }
  }
  return result;
}

/**Función que inicia la revisión del form entrante.
 *
 * @param {*} parameterFields, parametros de los campos a revisar.
 * @param {*} formInput, campos del form a revisar.
 * @returns id del campo y la condición que no haya pasado la validación.
 */
export function checkForm(rootValue, parameterFields, formInput) {
  //console.log(formInput)
  //console.log("Empezando la validación del form...")
  root = rootValue;
  let result = ['-1', null];
  for (let value in formInput) {
    if (result[0] == '-1') {
      for (const element of parameterFields) {
        //console.log(value+" "+parameterFields[i].id)
        if (element.id == value) {
          result = validateFormField(element, formInput[value], result);
          break;
        }
      }
    } else {
      break;
    }
  }
  //Si existe un error, inicia el popover con la notificación correspondiente.
  if (result[0] != '-1') {
    setPopoverData(getMessageValidation(result[1]));
    showPopover(parameterFields, result[0]);
    return false;
  }
  return true;
}

export function getPopoverData() {
  return currentPopoverData;
}

function setPopoverData(field) {
  currentPopoverData = field;
}

function showPopover(parameterFields, id) {
  const wrongClass = 'wrong-input';
  hideAllPopover(parameterFields, id);
  root.$emit('bv::show::popover', id);
  const multiselect = document.querySelector(`#${id}`);
  if (multiselect) {
    multiselect.classList.add(wrongClass);
    return;
  } 
  if (document.getElementById(id)) {
    document.getElementById(id).classList.add(wrongClass);
  }
}

export function showSpecialPopover(parameterFields, id) {
  const wrongClass = 'wrong-input';
  hideAllPopover(parameterFields, id);
  root.$emit('bv::show::popover', id);
  const multiselect = document.querySelector(`#${id} .multiselect`);
  if (multiselect) {
    multiselect.classList.add(wrongClass);
    return;
  }
  document.getElementById(id).classList.add(wrongClass);
}

export function hidePopover(rootValue, id) {
  const wrongClass = 'wrong-input';
  rootValue.$emit('bv::hide::popover', id);
  const multiselect = document.querySelector(`#${id} .multiselect`);
  if (multiselect) {
    multiselect.classList.remove(wrongClass);
    return;
  }
  document.getElementById(id).classList.remove(wrongClass);
}

function hideAllPopover(parameterFields, id) {
  for (let i = 0; i < parameterFields.length; i++) {
    if (parameterFields[i].id != id) {
      root.$emit('bv::hide::popover', parameterFields[i].id);
    }
  }
}

/**Función que entrega la validación no cumplida del campo.
 *
 * @param {*} validationTypeMessage, el tipo de mensaje de error.
 * @returns mensaje de error.
 */
export function getMessageValidation(validationTypeMessage) {
  return formFieldMessage[validationTypeMessage];
}
